import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/5511976658938"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Fale conosco no WhatsApp"
      data-testid="whatsapp-floating-button"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping group-hover:opacity-60" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe57] shadow-[0_12px_30px_rgba(37,211,102,0.45)] transition-transform group-hover:-translate-y-0.5">
        <MessageCircle size={26} className="text-white" strokeWidth={2} />
      </span>
    </a>
  );
}
